import { Language } from "./types"

export const languages: Language[] = [
  {
    code: "bs",
    display_name: "Bosanski",
    ltr: true,
    date_locale: () => import("date-fns/locale/bs").then((m) => m.bs),
  },
  {
    code: "bg",
    display_name: "Български",
    ltr: true,
    date_locale: () => import("date-fns/locale/bg").then((m) => m.bg),
  },
  {
    code: "en",
    display_name: "English",
    ltr: true,
    // Note: fallback enUS handled in hook if needed, but we provide it dynamically anyway
    date_locale: () => import("date-fns/locale/en-US").then((m) => m.enUS),
  },
  {
    code: "es",
    display_name: "Español",
    ltr: true,
    date_locale: () => import("date-fns/locale/es").then((m) => m.es),
  },
  {
    code: "el",
    display_name: "Ελληνικά",
    ltr: true,
    date_locale: () => import("date-fns/locale/el").then((m) => m.el),
  },
  {
    code: "de",
    display_name: "Deutsch",
    ltr: true,
    date_locale: () => import("date-fns/locale/de").then((m) => m.de),
  },
  {
    code: "fr",
    display_name: "Français",
    ltr: true,
    date_locale: () => import("date-fns/locale/fr").then((m) => m.fr),
  },
  {
    code: "he",
    display_name: "עברית",
    ltr: false,
    date_locale: () => import("date-fns/locale/he").then((m) => m.he),
  },
  {
    code: "hu",
    display_name: "Magyar",
    ltr: true,
    date_locale: () => import("date-fns/locale/hu").then((m) => m.hu),
  },
  {
    code: "it",
    display_name: "Italiano",
    ltr: true,
    date_locale: () => import("date-fns/locale/it").then((m) => m.it),
  },
  {
    code: "ja",
    display_name: "日本語",
    ltr: true,
    date_locale: () => import("date-fns/locale/ja").then((m) => m.ja),
  },
  {
    code: "pl",
    display_name: "Polski",
    ltr: true,
    date_locale: () => import("date-fns/locale/pl").then((m) => m.pl),
  },
  {
    code: "ptBR",
    display_name: "Português (Brasil)",
    ltr: true,
    date_locale: () => import("date-fns/locale/pt-BR").then((m) => m.ptBR),
  },
  {
    code: "tr",
    display_name: "Türkçe",
    ltr: true,
    date_locale: () => import("date-fns/locale/tr").then((m) => m.tr),
  },
  {
    code: "th",
    display_name: "ไทย",
    ltr: true,
    date_locale: () => import("date-fns/locale/th").then((m) => m.th),
  },
  {
    code: "uk",
    display_name: "Українська",
    ltr: true,
    date_locale: () => import("date-fns/locale/uk").then((m) => m.uk),
  },
  {
    code: "ro",
    display_name: "Română",
    ltr: true,
    date_locale: () => import("date-fns/locale/ro").then((m) => m.ro),
  },
  {
    code: "mk",
    display_name: "Македонски",
    ltr: true,
    date_locale: () => import("date-fns/locale/mk").then((m) => m.mk),
  },
  {
    code: "mn",
    display_name: "Монгол",
    ltr: true,
    date_locale: () => import("date-fns/locale/mn").then((m) => m.mn),
  },
  {
    code: "ar",
    display_name: "العربية",
    ltr: false,
    date_locale: () => import("date-fns/locale/ar").then((m) => m.ar),
  },
  {
    code: "zhCN",
    display_name: "简体中文",
    ltr: true,
    date_locale: () => import("date-fns/locale/zh-CN").then((m) => m.zhCN),
  },
  {
    code: "fa",
    display_name: "فارسی",
    ltr: false,
    date_locale: () => import("date-fns/locale/fa-IR").then((m) => m.faIR),
  },
  {
    code: "cs",
    display_name: "Čeština",
    ltr: true,
    date_locale: () => import("date-fns/locale/cs").then((m) => m.cs),
  },
  {
    code: "ru",
    display_name: "Русский",
    ltr: true,
    date_locale: () => import("date-fns/locale/ru").then((m) => m.ru),
  },
  {
    code: "lt",
    display_name: "Lietuviškai",
    ltr: true,
    date_locale: () => import("date-fns/locale/lt").then((m) => m.lt),
  },
  {
    code: "vi",
    display_name: "Tiếng Việt",
    ltr: true,
    date_locale: () => import("date-fns/locale/vi").then((m) => m.vi),
  },
  {
    code: "id",
    display_name: "Bahasa Indonesia",
    ltr: true,
    date_locale: () => import("date-fns/locale/id").then((m) => m.id),
  },
  {
    code: "ko",
    display_name: "한국어",
    ltr: true,
    date_locale: () => import("date-fns/locale/ko").then((m) => m.ko),
  },
  {
    code: "nl",
    display_name: "Nederlands",
    ltr: true,
    date_locale: () => import("date-fns/locale/nl").then((m) => m.nl),
  },
]
